export default {
  default: () => import("D:/a/1/s/frontend/web/src/layouts/default.vue").then(m => m.default || m),
  empty: () => import("D:/a/1/s/frontend/web/src/layouts/empty.vue").then(m => m.default || m)
}